const Endpoints = {
    accountHasRoles: {
        getAccountHasRoles: "/api/v2/account-has-roles/{id}",
    },
    addOnPriceTiers: "/api/v2/add-on-price-tiers",
    aiSettings: {
        generatedReportTexts: "/api/v2/generated-report-texts",
        inevitusChatTemplates: "/api/v2/inevitus-chat-templates",
        inevitusPromptSnippets: "/api/v2/inevitus-prompt-snippets",
        inevitusSettings: "/api/v2/inevitus-settings",
        projectExtractedContent: "/api/v2/project-extracted-contents",
    },
    assessmentReport: {
        calculatedScores: "/api/v2/calculated-scores",
        deletePdfReport: "/api/v1.1/generated-pdf-report/{participantSessionId}/delete",
        exampleReport: "/api/v1.1/example-report", // for copied example reports
        exampleReportDetailPage: "/api/v1.1/example-report/{reportSlug}/{sectionHandle}", // for copied example reports
        generatePdfReport: "/api/v1.1/generated-pdf-report/{participantSessionId}",
        getExampleReport: "/api/v1/get-example-assessment-report-data/{language}/{product}",
        getExampleReportDetailPage: "/api/v1/get-example-assessment-report-section-data/{language}/{product}/{section}",
        getGeneratedPdfReport: "/api/v2/generated-pdf-reports/{id}",
        getReport: "/api/v1/get-assessment-report-data/{participantSessionSlug}",
        getReportDetailPage:
            "/api/v1/get-assessment-report-section-data/{participantSessionSlug}/{reportSectionHandle}",
        interpretationCompetencyScore: "/api/v1.1/interpretations/competency",
        interpretationText: "/api/v1.1/interpretations/note",
        resendReport: "/api/v1.1/report/{participantSessionId}/resend",
        retriggerCalculation: "/api/v1.1/scores/debug/re-trigger-calculation/{participantSession}/regular",
        saveReflectionExerciseText:
            "/api/v1/submit-reflection-exercise-on-report/{participantSessionSlug}/{fieldHandle}",
        saveReflectionText: "/api/v1/submit-reflection-on-report/{participantSessionSlug}",
        sendReport: "/api/v1.1/hybrid-assessment/{participantSessionId}/finalize",
    },
    authorise: "/api/v1/user/authorize/tenant",
    authoriseWithTenant: "/api/v1/user/authorize/tenant/{organisationSlug}",
    builder: {
        questionnaireChoices: "/api/v2/questionnaire-question-choices/{id}",
        questionnaireQuestion: "/api/v2/questionnaire-questions/{id}",
        questionnaireQuestions: "/api/v2/questionnaires/{id}",
        questionnaireQuestionText: "/api/v2/questionnaire-texts/{id}",
        questionnaires: "/api/v2/questionnaires",
        uploadImage: "/api/v1.1/questionnaire-builder/upload-image/{translationKey}",
    },
    cacheManager: {
        clearCache: "/api/v1.1/cache/clear",
        invalidateTag: "/api/v1.1/cache/invalidate/{tag}",
    },
    deactivateAccount: "/api/v2/accounts/deactivate",
    entraLogin: "/api/v1.1/login/microsoft",
    entraRedirect: "/api/v1.1/authorize/microsoft",
    entraRegister: "/api/v1.1/register/{accountHasRoleSlug}/microsoft",
    featureFlagsSearch: "/api/v2/feature-flags",
    finance: {
        amendCostHeading: "/api/v1/billing/participant-session-cost-heading/{participantSessionSlug}",
        exportFilteredInvoices: "/api/v1.1/invoices/export",
        markInvoicesAsBilledOrUnbilled: "/api/v1.1/invoices/{billedToggle}",
        overview: "/api/v1.1/invoices/overview",
        requestAssessmentOrganisations: "/api/v1/organisations/hierarchy",
    },
    flattenedOrganisations: "/api/v1.1/organisations/hierarchy",
    forgotPassword: {
        changePassword: "/api/v1/user/change-password",
        requestEmail: "/api/v1/user/request-password",
        validateToken: "/api/v1/user/verify-password-reset/{email}/{token}",
    },
    groupReports: {
        createGroupAndGroupReport: "/api/v1.1/group-reports/create-group-report{parameters}",
        // Generic endpoint, used for group report receivers
        getGroupReport: "/api/v2/group-reports/{id}",

        getGroupReports: "/api/v2/group-reports{parameters}",

        // Custom endpoint for group report with data
        getGroupReportWithData: "/api/v1.1/group-reports/{id}",

        groupReports: "/api/v2/group-reports",
        inviteGroupReportReceiver: "/api/v1.1/group-reports/{id}/invite-user",
        removeGroupReportReceiver: "/api/v2/group-reports/{id}/remove-group-report-receiver",
    },
    habileLogin: "/api/v1.1/login/klm",
    habileRedirect: "/api/v1.1/authorize/klm",
    habileRegister: "/api/v1.1/register/{accountHasRoleSlug}/klm",
    hierarchyForIdV2: "/api/v2/organisations/{id}/hierarchy",
    hierarchyV2: "/api/v2/organisations/hierarchy",
    homeTab: {
        createPipedriveLead: "/api/v1.1/pipedrive-leads",
    },
    intermediateReport: {
        getIntermediateReport: "/api/v1/get-intermediate-report-data/{participantSessionSlug}",
    },
    internal: {
        platformVersion: "/api/v1.1/platform-version",
    },
    listQuestionnaires: "/api/v2/settings-for-questionnaires",
    listQuestionnairesForProject: "/api/v1/get-questionnaire-settings-for-project/{projectSlug}",
    logout: "/api/v1/user/logout",
    magicLink: {
        useLink: "/api/v2/login-links/{linkHash}",
    },
    masquerade: "/api/v2/account/masquerade",
    organisation: "/api/v2/organisations",
    organisationBranding: "/api/v1/organisation/{organisationSlug}/branding",
    organisationSettings: {
        addMultipleRoles: "/api/v2/accounts/{accountId}/roles",
        addUserInfo: "/api/v1/account/portal-get-info-when-add-account",
        addUserWithoutInvite: "/api/v1/account/add-without-invite",
        afasOrganisations: "/api/v2/afas-organisations",
        afasProjects: "/api/v2/afas-projects",
        afasRooms: "/api/v1.1/afas-rooms",
        afasRoomsV2: "/api/v2/afas-rooms",
        amendOrganisationAfas: "/api/v2/organisations/{id}/afas",
        anonymizeAfter: "/api/v2/organisations/{id}/anonymize_after",
        appointment: "/api/v2/appointments/{id}",
        appointments: "/api/v2/appointments",
        assessmentTemplates: "/api/v2/assessment-templates",
        cancelAppointment: "/api/v2/appointments/{id}/cancel",
        competencies: "/api/v1/competencies-for-project/{slug}",
        competencyAliases: "/api/v2/competency-aliases",
        createCompetencyAlias: "/api/v2/competency-aliases",
        createNewCustomQuestion: "/api/v2/custom-questions",
        createScoreSettingCutoffs: "/api/v2/score-setting-cutoffs",
        customCompetencies: "/api/v2/competencies",
        customQuestions: "/api/v2/custom-questions/{customQuestionId}",
        deactivateJobFunction: "/api/v1/project/{slug}/deactivate",
        deactivateOrganisation: "/api/v1.1/organisations/{id}/deactivate",
        deleteRoleFromUser: "/api/v1/delete-role",
        exportOrganisationApiSettingsCsv: "/api/v1/api-integration/fields-export-csv/{organisationSlug}",
        exportUsersAsCsv: "/api/v1/user/export",
        getAfasPrograms: "/api/v1.1/get-afas-programs/{organisationId}",
        getCompetencyAliases: "/api/v1.1/competency-with-aliases/{competencyId}/organisation/{organisationId}",
        getCompetencyAliasTags: "/api/v1.1/competency-alias-tags/{organisationId}",
        getGenericAfasPrograms: "/api/v1.1/get-afas-programs",
        getScoreSettings: "/api/v2/score-settings",
        getTextTemplates: "/api/v1/{entityType}/{projectSlug}/{productSlug}/text-templates",
        getUserDetails: "/api/v1/account/{slug}/portal-amend-user-info",
        hierarchy: "/api/v1/organisations/hierarchy",
        hierarchyForId: "/api/v1/organisations/hierarchy/{organisationSlug}",
        inviteUser: "/api/v1/user/invite",
        organisation: "/api/v2/organisations/{id}",
        organisationAndRoles: "/api/v1/organisation-roles-form/{slug}",
        organisationLogoUpload: "/api/v1/organisation/{organisationSlug}/upload-logo",
        organisationSectors: "/api/v2/organisation-sectors{parameters}",
        productLicenses: "/api/v2/organisation-product-licenses",
        products: "/api/v1/organisation/{slug}/products",
        professionalCategories: "/api/v2/professional-categories",
        projectFeature: "/api/v2/projects/{id}/feature",
        projectFile: "/api/v1.1/projects/{id}/files/{fileId}",
        projectProductTemplates: "/api/v2/project-product-templates",
        projects: "/api/v2/projects/{id}",
        saveAssessmentProgramSettings:
            "/api/v1.1/update-questionnaire-settings-for-project/{projectSlug}/{questionnaireGroupHandle}/{slugOfProduct}",
        saveProductAlias: "/api/v2/product-aliases",
        saveProductSelection: "/api/v1/organisation/{slug}/update-products",
        saveQuestionnaireActiveForProject:
            "/api/v1.1/update-questionnaire-settings-for-project/{projectSlug}/{questionnaireGroupHandle}/{slugOfProduct}",
        saveTextTemplateForOrganisation: "/api/v1/update-or-create-text-template-for-organisation/{slug}/{productSlug}",
        saveTextTemplateForProject: "/api/v1/update-or-create-text-template-for-project/{slug}/{productSlug}",
        scoreSettingCutoffs: "/api/v2/score-setting-cutoffs/{id}",
        setProductAddonAvailable: "/api/v1/product-add-on/available/for/organisation",
        setProductAddonUnavailable:
            "/api/v1/product-add-on/unavailable/organisation/{organisationSlug}/{productAddonSlug}",
        updateCompetencyAlias: "/api/v2/competency-aliases/{id}",
        updateScoreSettings: "/api/v2/score-settings/{id}",
        uploadProjectFile: "/api/v1.1/projects/{id}/files",
        users: "/api/v1/organisation/{slug}/users",
    },
    organisationTenants: "/api/v1/organisation-tenant/hierarchy",
    participants: {
        addAddOnForParticipant: "/api/v1/product-add-on/active/participant-session",
        addParticipantFormInfo: "/api/v1/participantSession/get-info-with-competencies",
        addParticipantToGroup: "/api/v2/groups/{id}/add-participant-session",
        adjustedProgramSetting: "/api/v1.1/multiphase/dyslexia/{participantSession}",
        anonymize: "/api/v2/account-has-roles/{id}/anonymize",
        appointmentSettings: "/api/v2/participant-sessions/{id}/appointment-settings",
        batchUpdateAssessmentOutcome: "/api/v1.1/participant-sessions/batch-update-outcome",
        closePhase: "/api/v2/participant-sessions/{id}/close",
        competenciesForParticipant: "/api/v1/participantSession/{participantSessionSlug}/get-competencies",
        dashboardData: "/api/v1.1/dashboards/participant-data",
        deleteAddOnForParticipant:
            "/api/v1/product-add-on/inactive/participant-session/{participantSessionSlug}/{productAddOnSlug}",
        deleteCv: "/api/v1/delete-file-for-account/{slug}",
        downloadCv: "/api/v1/download-cv/{slug}",
        filterMenu: {
            filterMenuItems: "/api/v1/get-organisation-filter{parameters}",
            organisations: "/api/v1/get-top-level-organisations",

            organisationsTree: "/api/v1.1/organisations/hierarchy",
            // to fetch all root organisations for all logged user's roles
            rootOrganisations: "/api/v1.1/account/root-organisations",
        },
        getAlternativeProjects: "/api/v1.1/participant-sessions/{id}/alternative-projects",
        getAssessmentConfig: "/api/v1/assessment-config/{participantSessionSlug}",
        getAssessmentProgramSettings: "/api/v1/assessment-settings-for-participant/{participantSessionSlug}",
        getFeatureFlags: "/api/v1.1/feature/access",
        getImportProgress: "/api/v1/task/{processId}/get-progress",
        getParticipantDetails: "/api/v1/participantSession/{slug}/participant-info",
        getParticipantLogs: "/api/v1.1/assessment/{id}/logs",
        getParticipants: "/api/v2/participant-sessions/overview{parameters}",
        getParticipantsList: "/api/v2/participant-sessions/list{parameters}",
        groups: "/api/v2/groups",
        groupsOverview: "/api/v2/groups/overview",
        importParticipants: "/api/v1/participantSession/import",
        importParticipantsCsv: "/api/v1/project/{projectSlug}/import-participants",
        initReset: "/api/v1/init-reset/{participantSessionSlug}/{questionnaireHandle}",
        inviteParticipants: "/api/v1/participant/invite",
        markPresent: "/api/v2/participant-sessions/present",
        moveProject: "/api/v2/participant-sessions/{id}/move-project",
        organisationDataForParticipant:
            "/api/v1/participantSession/{participantSessionSlug}/get-report-receivers-with-organisation-data",
        participantSession: "/api/v2/participant-sessions/{id}",
        participantSessionFile: "/api/v1.1/participant-sessions/{id}/files/{fileId}",
        remindParticipants: "/api/v1/participant/remind-multiple",
        removeParticipantFromGroup: "/api/v2/groups/{id}/remove-participant-session",
        requestAssessmentOrganisations: "/api/v1/organisations/hierarchy",
        retriggerScoresForParticipant: "/api/v2/participant-sessions/{id}/retrigger-calculation",
        saveAssessment: "/api/v1.1/assessment",
        saveAssessmentProgramSettings: "/api/v1/participantSession/{participantSessionSlug}/update",
        searchOverview: "/api/v1/client-participant-overview",
        setPhase: "/api/v2/participant-sessions/{id}/phase",
        switchGoal: "/api/v2/participant-sessions/{id}/switch-goal",
        switchProduct: "/api/v2/participant-sessions/{id}/switch-product",
        updateAddOns: "/api/v2/participant-sessions/{id}/add-ons",
        updateInterpretations: "/api/v2/participant-sessions/{id}/interpretations",
        updateParticipant: "/api/v2/participant-sessions/{id}/info",
        uploadCv: "/api/v1/update-or-create-file-for-account/{slug}",
        uploadParticipantFile: "/api/v1.1/participant-sessions/{id}/files",
    },
    planningDashboard: "/api/v1.1/planning-dashboard",
    productPriceTiers: "/api/v2/product-price-tiers",
    products: "/api/v2/products/{id}",
    profile: {
        getAccountDetails: "/api/v1/account/{slug}/amend-user-info",
        saveAccountLanguage: "/api/v2/accounts/{accountId}/sync-language",
    },
    project: "/api/v2/projects",
    register: {
        accountLogin: "/api/v1/user/invite/login/{slug}",
        accountStatus: "/api/v1/user/status/{slug}",
        createAccount: "/api/v1/user/invite/create-account/{slug}",
        participantAcceptTerms: "/api/v1/participant/invite/terms-and-conditions/{slug}",
    },
    sectionAdd: "/api/v1/{section}/add",
    sectionInfo: "/api/v1/{section}/info",
    sectionUpdate: "/api/v1/{section}/{slug}/update",
    sectionWithSlug: "/api/v1/{section}/{slug}",
    setPageAsVisited: "/api/v2/accounts/{accountId}/log-pages",
    settingsForQuestionnaires: "/api/v2/settings-for-questionnaires",
    teams: {
        addTeamMember: "/api/v2/groups/{id}/add-participant-session",
        detail: "/api/v2/groups/{id}",
        flattenedOrganisations: "/api/v1.1/organisations/flat",
        groupDashboard: "/api/v1.1/group-dashboard/{id}",
        organisation: "/api/v1.1/organisations/with-teams",
        searchParticipants: "/api/v1.1/participant-sessions/for-teams?term=",
    },
    topLevelOrganisations: "/api/v1.1/account/top-level-organisations",
    users: {
        assignRole: "/api/v2/accounts/{id}/assign-role",
        consultants: "/api/v1.1/consultants",
        createUser: "/api/v2/accounts/create-user",
        getUserDetails: "/api/v2/accounts/{id}",
        invite: "/api/v1.1/accounts/invite/{accountHasRoleId}",
        inviteUser: "/api/v1.1/accounts/invite/{ahrId}",
        ltpUsers: "/api/v1/ltp-user-overview",
        planners: "/api/v1.1/planners",
        unassignRole: "/api/v2/accounts/{id}/unassign-role",
        updateUserDetails: "/api/v2/accounts/{id}/update-user",
        updateUserRoles: "/api/v2/accounts/{id}/roles",
    },
};

export default Endpoints;
